import { combineReducers } from "@reduxjs/toolkit";
import userSessionSlice from "./UserSession";
import notificationSlice from "./Notification";
import adapterSlice from "./Adapters";

export default combineReducers({
   usersession: userSessionSlice,
   notification: notificationSlice,
   adapters: adapterSlice
})